export default (
	state = {
		sideShow: false,
	},
	action
) => {
	switch (action.type) {
		case "SIDESHOW_HANDLE":
			return { ...state, sideShow: !state.sideShow }
		default:
			return state
	}
}
